import React, {useState} from 'react';
import {Button, useNotify, useRefresh, useUnselectAll, useUpdateMany} from "react-admin";
import Popover from "@material-ui/core/Popover";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import {useQueryWithStore} from "react-admin";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import WorkIcon from "@material-ui/icons/Work";

const MoveToPositionPopover = props => {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [position, setPosition] = useState(null);
  const {selectedIds} = props;
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll();
    const [updateMany] = useUpdateMany(
        'employees',
        selectedIds,
        { positionId: position ? position.id : null },
        {
            onSuccess: () => {
                refresh();
                notify(` ${selectedIds.length} Employees Moved to Position ${position.name}`);
                unselectAll('employees');
            },
            onFailure: error => notify('Error: Some Employees cannot be moved to position', 'warning'),
        }
    );


    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMove= () => {
        updateMany()
        setAnchorEl(null);
    };
    const { data: positions} = useQueryWithStore({
        type: 'getList',
        resource: 'positions',
        payload: {filter:{},pagination:{},sort:{}}
    });

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
        <div>
            <Button label={props.label} aria-describedby={id} variant="text" color="primary" onClick={handleClick}>
                <WorkIcon/>
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Card style={{minWidth:400}}>
                    <CardContent>
                        <Autocomplete
                            options={positions || []}
                            getOptionLabel={(option) => option.name || ''}
                            onChange={(event, value) => setPosition(value)}
                            renderInput={(params) => <TextField {...params} label="To Position" style={{width: 350}} />}
                        />
                    </CardContent>
                    <CardActions>
                        <Button label='OK' disabled={!position} style={{ marginLeft: 'auto'}} onClick={handleMove} variant="text" color="primary">

                        </Button>
                    </CardActions>
                </Card>

            </Popover>
        </div>
    );
};

export default MoveToPositionPopover;
